import React, {useState} from "react";
import PropTypes from "prop-types";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ClearButton } from "components/Shared";

const DateField = ({
  label,
  innerRef,
  onChange,
  defaultValue,
  onClear,
  ...otherProps
}) => {
    const [visible, setVisible] = useState(defaultValue);
    const [value, setValue] = useState(defaultValue ? new Date(defaultValue) : null);
    return (<>
      {label}
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          {...otherProps}
          ref={innerRef}
          value={value}
          onChange={(newValue) => {
            setValue(newValue);
            onChange(null, newValue);
            setVisible(true);
          }}
          closeOnSelect={true}
          slotProps={{ textField: { variant: 'standard' } }}
        />
      </LocalizationProvider>
      <ClearButton 
        {...{visible}}
        onClick={() => {
          setValue(null);
          onClear();
          setVisible(false);
        }}
      />
    </>);
};

DateField.defaultProps = {
  label: "",
  onChange: () => {},
  defaultValue: null,
  onClear: () => {},
  innerRef: {},
};

DateField.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  innerRef: PropTypes.object,
  onChange: PropTypes.func,
  defaultValue: PropTypes.string,
  onClear: PropTypes.func,
};

export default DateField;